<template lang='pug'>
span(:class="`pl-${ spacing[nutrient] * 4 }`") #[span(v-html='keyToLabelHtml(nutrient)')]#[span(v-html='"&nbsp;"')]#[span.font-weight-black {{ keyToUnit(nutrient) }}]
</template>

<script>
import {
  keyToLabelHtml,
  keyToUnit,
} from '@thomasphan/helpers-fatsecret';

const spacing =
{
  calories: 0,
  fat: 0,
  saturated_fat: 1,
  trans_fat: 1,
  monounsaturated_fat: 1,
  polyunsaturated_fat: 1,
  cholesterol: 0,
  sodium: 0,
  carbohydrate: 0,
  fiber: 1,
  sugar: 1,
  added_sugars: 2,
  protein: 0,
  vitamin_a: 0,
  vitamin_c: 0,
  vitamin_d: 0,
  calcium: 0,
  iron: 0,
  potassium: 0,
};

export default
{
  data()
  {
    return {
      spacing
    };
  },
  methods:
  {
    keyToLabelHtml,
    keyToUnit,
  },
  props:
  {
    nutrient: { required: true }
  },
};
</script>